import React, { useState } from "react";
import Layout from "../../../../common/layout";
import { Select, Tabs } from "antd";
import GeneralTable from "./reportTables/GeneralTable";



const Reports = () => {



  const [activeTab, setActiveTab] = useState(); 
  const [showTotalPayout,setShowTotalPayout] = useState()
  const [monthFilter,setMonthFilter] = useState(0)

  const totalPayout = showTotalPayout?.reduce((total, item) => {
    if (item.approvedConversions && item.approvedConversions.payout) {
      return total + parseInt(item.approvedConversions.payout, 10);
    }
    return total;
  }, 0);

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  




  const tabItems = [
    {
      key: "general",
      label: <p className="font-Mulish font-semibold text-base md:text-xl">General</p>,
      children: (
        <GeneralTable
          setShowTotalPayout={setShowTotalPayout}
          monthFilter={monthFilter}
        />
      ),
    },
  ];
  const handleTabChange = (key) => {
    setActiveTab(key);
    // setOffersTabKey(key);
    // setReRender(true);
  };
  
  return (
    <Layout>
      <div className="px-4 md:px-8 py-6">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between md:items-center gap-4">
          <h1 className="capitalize font-semibold text-xl md:text-2xl">Reports</h1>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4">
            <p className="capitalize font-medium text-base md:text-lg">
              Total Payout - {totalPayout || 0}
            </p>

            <Select
              defaultValue="January"
              className="w-full sm:w-[170px]"
              onChange={(e) => setMonthFilter(e)}
            >
              {months.map((month, index) => (
                <Select.Option key={index} value={index}>
                  {month}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>

        {/* Tabs Section */}
        <div className="w-full mt-6 overflow-x-auto">
          <Tabs
            activeKey={activeTab}
            items={tabItems}
            className="adminOffers"
            onChange={(e) => handleTabChange(e)}
          />
        </div>
      </div>
    </Layout>
  );
};

export default Reports;
